import OrganizationTransferConfirm from '@/screens/OrganizationTransferConfirm';

export default function Route() {
  return <OrganizationTransferConfirm />;
}
